export default __webpack_public_path__ + "static/media/falcon-join-hover.a1487386.svg";